import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Company, CompanySummary } from './company';
import { BaseIndexedDbRepository } from 'libs/arch/src/lib/repositories/indexed-db/indexdb-repository';
import { SynchronizationService } from 'libs/arch/src/lib/repositories/indexed-db/synchronization.service';
import { ApiService, NetworkStatusService } from '@homeleite/arch';
import { map, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CompanyRepository extends BaseIndexedDbRepository<CompanySummary, Company> {
    protected readonly storeName: string = 'companies';

    constructor(
        protected override readonly dbService: NgxIndexedDBService,
        protected override readonly synchronizationService: SynchronizationService,
        private readonly apiService: ApiService,
        private readonly networkStatus: NetworkStatusService
    ) {
        super(dbService, synchronizationService);
    }

    protected getResourcePath(): string {
        return 'companies';
    }

    protected getSearchableFields(): string[] {
        return ['name', 'apcId'];
    }

    protected override mapToEntity(dbItem: Company): Company {
        return Company.fromJson(dbItem);
    }

    protected mapToSummary(item: Company): CompanySummary {
        return CompanySummary.fromJson(item);
    }

    findByName(name: string): Observable<CompanySummary> {
        return super.listFull().pipe(
            map(companies => {
                const found = companies.find(c => c.name === name);
                return found ? this.mapToSummary(found) : null;
            })
        );
    }
}
